import { render, staticRenderFns } from "./receipt-summary.vue?vue&type=template&id=1d4c768f&scoped=true"
import script from "./receipt-summary.vue?vue&type=script&lang=ts"
export * from "./receipt-summary.vue?vue&type=script&lang=ts"
import style0 from "./receipt-summary.vue?vue&type=style&index=0&id=1d4c768f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c768f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4c768f')) {
      api.createRecord('1d4c768f', component.options)
    } else {
      api.reload('1d4c768f', component.options)
    }
    module.hot.accept("./receipt-summary.vue?vue&type=template&id=1d4c768f&scoped=true", function () {
      api.rerender('1d4c768f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboards/pages/ds/pages/receipt-summary/receipt-summary.vue"
export default component.exports